export const email = "mariaanworks@gmail.com";

export const resumeUrl = "/Maria An - Software Engineer.pdf";

export const socialMedia = [
  { name: "GitHub", url: "https://github.com/maria-an11" },
  { name: "Linkedin", url: "https://www.linkedin.com/in/maria-an11/" },
];

export const navLinks = [
  { name: "About", url: "about" },
  { name: "Projects", url: "projects" },
  { name: "Contact", url: "contact" },
];
